import * as React from 'react';
import { DetailsBooking } from 'types';
import PaymentSummaryComponent from 'components/PaymentSummary';
import { bookingToPaymentSummaryProps } from 'components/PaymentSummary/utils';

const PaymentSummary: React.FC<{ booking: DetailsBooking }> = ({ booking }) => {
  const { transactionAmounts } = bookingToPaymentSummaryProps(booking);
  return <PaymentSummaryComponent transactionAmounts={transactionAmounts} />;
};

export default PaymentSummary;
